import 'reflect-metadata';

import { Component, Inject, ViewEncapsulation } from '@angular/core';

import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend';
import { SearchConfigService, SearchConfigInstance } from '../../services/SearchConfigService'
import { Analytics } from '../../services/Analytics'

import { NgbModal, NgbActiveModal } from '@mattlewis92/ng-bootstrap';

import { Observable } from 'rxjs';

@Component({
    selector: 'user-report-modal',
    template: `<iframe class="userreport-iframe" src="https://feedback.userreport.com/6a4ce18a-d76d-4b07-8b17-2a43e1254440/"></iframe><div class="modal-footer"><button class="btn btn-transparent" style="float: left;" ng-click="$dismiss()">Close</button></div>`
})
export class UserReportModalComponent {
    constructor(private activeModal: NgbActiveModal) {}
}

@Component({
    selector: 'app',
    templateUrl: './app.html',
    styleUrls: ['./app.css', './app.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
    profilePicUrl:Observable<string>;
    isLoggedIn:Observable<boolean>;
    username:Observable<string>;

    add_box_open:boolean = false;
    constructor(shelvableBackend:ShelvableBackend, searchConfigService:SearchConfigService, private modalService: NgbModal) {
        this.gettingStartedStages = shelvableBackend.gettingStartedStages;
        this.profilePicUrl = shelvableBackend.loggedInUserObs.profilePicUrlObs;
        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;
        this.username = shelvableBackend.loggedInUserObs.usernameObs;

        searchConfigService.config.subscribe((searchConfig) => {
            this.searchConfig = searchConfig;
        });
        
        if (document.getElementById('cf_alert_div')) {
            Analytics.servedByCloudflareAlwaysOnline();
        }
        

    }

    rot13(s)
    {
       return (s ? s : this).split('').map(function(_)
        {
           if (!_.match(/[A-Za-z]/)) return _;
           var c = Math.floor(_.charCodeAt(0) / 97);
           var k = (_.toLowerCase().charCodeAt(0) - 83) % 26 || 26;
           return String.fromCharCode(k + ((c == 0) ? 64 : 96));
        }).join('');
    }

    atob = (a) => window.atob(a);

    searchConfig:SearchConfigInstance;
    
    async showUserReport() {
        try {
            await this.modalService.open(UserReportModalComponent, {size: 'lg'}).result;
        } catch {
            console.log('User report modal closed.');
        }
    }
    
    gettingStartedStages:any;
};


// WEBPACK FOOTER //
// ./web/static/components/app/app.ts